<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="this.language['ad.name']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
              <a-input v-model="model.name" :placeholder="this.language['ad.must.name']"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item :label="this.language['ad.introduction']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
              <a-textarea v-model="model.remark" :placeholder="this.language['ad.must.introduction']" rows="2"></a-textarea>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['ad.link']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="link">
              <a-input v-model="model.link" :placeholder="this.language['ad.must.link']" v-decorator="[ 'link', validatorRules.url]"></a-input>


            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['ad.position']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="adPosition">
              <j-dict-select-tag type="list" v-model="model.adPosition" dictCode="ad_position"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['ad.type']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="mediaType">
              <j-dict-select-tag type="list" v-model="model.mediaType" dictCode="ad_file_type"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['ad.image']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="imageUrl">
              <j-image-upload v-model="model.imageUrl"></j-image-upload>
            </a-form-model-item>
          </a-col>
<!--          <a-col :span="24">-->
<!--            <a-form-model-item :label="this.language['ad.endtime']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="endTime">-->
<!--              <a-date-picker-->
<!--                format="YYYY-MM-DD" :disabled-date="disabledDef" :disabled="formDisabled?disabled:false"-->
<!--                v-model="model.endTime" style="width: 100%"></a-date-picker>-->
<!--            </a-form-model-item>-->
<!--          </a-col>-->

          <a-col :span="24">
            <a-form-model-item :label="this.language['ad.status']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="status">
              <j-dict-select-tag v-model="model.status" :type="'radio'" dictCode="ad_status"/>
            </a-form-model-item>

          </a-col>


          <a-col :span="24">
            <a-form-model-item :label="this.language['common.sort']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sortNo">
              <a-input-number  :precision="0" v-model="model.sortNo" placeholder="请输入顺序"
                              style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['eletronicSigned.affiliationApplication']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationId">
              <a-select v-model="model.applicationId" allowClear>
                <a-select-option v-for="(application,index) in applicationList" :key="index.toString()"
                                 :value="application.id">
                  {{ application.applicationName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>


<script>

import {httpAction, getAction} from '@/api/manage'
import {validateDuplicateValue} from '@/utils/util'
import moment from "moment";

export default {
  name: 'SysBmAdForm',
  components: {},
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      applicationList: [],
      model: {},
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
      confirmLoading: false





      ,
      url: {
        add: "/sys/ad/add",
        edit: "/sys/ad/edit",
        queryById: "/sys/ad/queryById"
      }
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    formDisabled() {
      return this.disabled
    },
    validatorRules() {
      if (this.language) {
        return {
          name: [
            {required: true, message: this.language['ad.must.name']},
            {min: 2, max: 60, message: this.language['common.lengthRange']+' 2 '+this.language['common.to']+' 60 '+this.language['common.character'], trigger: 'blur'}
          ],
          adPosition: [
            {required: true, message: this.language['ad.must']+this.language['ad.position']+'!'},
          ],
          mediaType: [
            {required: true, message: this.language['ad.must']+this.language['ad.type']+'!'},
          ], status: [
            {required: true, message: this.language['ad.must']+this.language['ad.status']+'!'},
          ],
          link: [
            {required: true, message:this.language['ad.must']+this.language['ad.link']+'!'},
            {min: 2, max: 255, message: this.language['common.lengthRange']+' 2 '+this.language['common.to']+' 255 '+this.language['common.character'], trigger: 'blur'},
            {validator: this.validateToUrl, trigger: 'blur'}
          ],
          remark: [
            {required: false},
            {min: 2, max: 500, message: this.language['common.lengthRange']+' 2 '+this.language['common.to']+' 500 '+this.language['common.character'], trigger: 'blur'},
          ],
          imageUrl: [
            {required: true, message: this.language['warning.pleaseUploadImage']+'!'},
          ], sortNo: [
            {required: true, message: this.language['common.mustSort']+'!'},
            {validator: this.validateToSortNo, trigger: 'blur'}
          ],
          applicationId: [
            {required: true, message: this.language['premission.mustApplication']+"!"},
          ],
        }
      }
    }

  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model));
    this.getApplicationList();
  },
  methods: {
    getApplicationList() {
      httpAction("/sys/role/getSysBmApplication", "", "get").then((res) => {
        if (res.success) {
          this.applicationList = res.result;
        }
      })
    },
    add() {
      this.edit(this.modelDefault);
    },
    edit(record) {
      this.model = Object.assign({}, record);
      this.visible = true;
    },
    
    validateToSortNo(rule, value, callback){
      if(value<1||value>500){
        callback("输入的值在1到500之间！");
      }else {
        let params = {
          sortNo: value,
          adPosition: this.model.adPosition,
          applicationId: this.model.applicationId,
          id:this.model.id
        };
        getAction("/sys/ad/doDuplicateCheck", params).then((res) => {
          if (res.success) {
            callback();
          }else{
            callback("相同应用、相同广告位下的排序不能重复！");
          }
        })
      }
    },
    validateToUrl(rule, value, callback) {
      let rul = /(http|https):\/\/([\w.]+\/?)\S*/;
      if (!(rul.test(value))) {
        callback(this.language['ad.link.rule']);
      } else {
        callback();
      }
    },
    disabledDef(current) {
      return current <= moment(this.model.correctiveTerm);
    },
    submitForm() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate(valid => {

        if (valid) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'put';
          }

          if(!this.model.imageUrl.includes('http')) {
            this.model.imageUrl = window._CONFIG['domianURL']+"/sys/common/static/" + this.model.imageUrl + '?applicationCode=platform'
          }
        
          httpAction(httpurl, this.model, method).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }

      })
    },
  }
}


</script>